import type { SupportedLocale } from '../../../../shared/i18n/locales';
import en from './en';
import zh from './zh';
import fr from './fr';
import es from './es';
import enCnSite from './en-cnsite';
import zhCnSite from './zh-cnsite';

export type MessageRegion = 'development' | 'us' | 'cn';

export const messages: Record<SupportedLocale, Record<string, string>> = {
  en,
  zh,
  fr,
  es,
};

function withEnglishFallback(locale: SupportedLocale) {
  return locale === 'en' ? messages.en : { ...messages.en, ...messages[locale] };
}

function withCnSiteFallback(locale: SupportedLocale) {
  const cnEnglish = { ...messages.en, ...enCnSite };

  if (locale === 'en') {
    return cnEnglish;
  }

  if (locale === 'zh') {
    return {
      ...cnEnglish,
      ...messages.zh,
      ...zhCnSite,
    };
  }

  return {
    ...cnEnglish,
    ...messages[locale],
  };
}

export function getMessagesForLocale(locale: SupportedLocale, region: MessageRegion) {
  return region === 'cn' ? withCnSiteFallback(locale) : withEnglishFallback(locale);
}
